import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge, BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import {
  ClientRiskToleranceSummaryList,
} from 'Components/ComponentLibrary/Organisms/ClientRiskToleranceSummaryList/ClientRiskToleranceSummaryList';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';


export default buildFacetDesignOverride()
  .nameOverride('moduleName', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('primaryText', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly)
  .nameOverride('secondaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride('clients', {
    _component: () => ClientRiskToleranceSummaryList,
  }, overrideReadOnly);
